export interface ArticleItem {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  image: string;
  date: string;
  views: number;
  comments: number;
  tags: string[];
  isHot: boolean;
  isFeatured: boolean;
}

export const categories: { name: string; slug: string; description: string; icon: string }[] = [
  { name: '娱乐圈黑料', slug: 'yulequan', description: '最新娱乐圈黑料爆料，明星塌房现场直击，八卦内幕一网打尽', icon: 'ri-movie-2-line' },
  { name: '主播塌房', slug: 'zhubo', description: '知名主播翻车实录，直播圈黑料大起底，每天都在上演新的塌房', icon: 'ri-live-line' },
  { name: '网红八卦', slug: 'wanghong', description: '网红圈最新爆料，短视频达人不为人知的另一面，吃瓜第一线', icon: 'ri-smartphone-line' },
  { name: '社会热点', slug: 'shehui', description: '网络热门事件追踪，社会话题深度挖掘，让你不错过每一个瓜', icon: 'ri-fire-line' },
];

export const articles: ArticleItem[] = [
  {
    id: 'article-1',
    title: '某顶流男星深夜密会神秘女子，粉丝集体塌房现场实况',
    excerpt: '据知情人士爆料，某顶流男星近日被拍到深夜与一名神秘女子同返公寓，两人举止亲密。消息一出，粉丝圈瞬间炸锅，大批粉丝表示"塌房了"。',
    content: `<p>近日，一则关于某顶流男星的爆料在网络上迅速发酵。据多位目击者称，该男星于上周五深夜被拍到与一名身材高挑的神秘女子一同进入某高档公寓，直至次日清晨才分别离开。</p>
<p>消息人士透露，两人在电梯内举止亲密，男方多次搂抱女方，完全不避讳公共场合的摄像头。这一行为与其平时在公众面前塑造的"高冷人设"形成鲜明对比。</p>
<p>爆料发布后，该男星的粉丝群体迅速分裂为两派。一部分粉丝表示"房子塌了，心碎了"，另一部分则坚持认为这只是一场误会，呼吁大家等待官方回应。</p>
<p>截至目前，该男星的工作室尚未对此事做出任何回应。据业内人士分析，如果此次爆料属实，该男星与多个品牌的代言合约可能面临解约风险。</p>
<p>值得一提的是，这已经不是该男星第一次陷入感情绯闻。去年就曾有网友爆料他与某女演员因戏生情，但当时双方均予以否认。</p>
<p>我们将持续关注此事的最新进展。</p>`,
    category: '娱乐圈黑料',
    categorySlug: 'yulequan',
    image: 'https://readdy.ai/api/search-image?query=Dimly%20lit%20luxury%20apartment%20entrance%20at%20night%2C%20two%20blurred%20silhouettes%20walking%20together%2C%20paparazzi%20style%20candid%20photography%2C%20warm%20golden%20street%20lamp%20lighting%2C%20mysterious%20and%20dramatic%20atmosphere%2C%20soft%20cinematic%20bokeh%20effect%2C%20dark%20tones%20with%20warm%20accents%2C%20editorial%20entertainment%20news%20photography%20style%2C%20clean%20composition%20with%20negative%20space&width=800&height=600&seq=article-1-cover&orientation=landscape',
    date: '2026-07-06',
    views: 128000,
    comments: 3621,
    tags: ['娱乐圈', '男星塌房', '深夜密会', '粉丝集体脱粉'],
    isHot: true,
    isFeatured: true,
  },
  {
    id: 'article-2',
    title: '知名带货主播直播间翻车，虚假宣传被当场拆穿',
    excerpt: '某拥有千万粉丝的带货主播在直播过程中，被专业网友当场指出产品参数造假。面对实锤证据，主播尴尬沉默数十秒后匆匆下播。',
    content: `<p>一场看似平常的带货直播，却因为一位"较真"网友的弹幕而彻底翻车。昨晚，拥有超过一千五百万粉丝的知名带货主播"XX好物推荐官"在直播推荐一款高价护肤品时，被观众当场指出宣传的成分浓度与实际产品不符。</p>
<p>事件起因是主播声称该产品含有"高达20%的玻尿酸精华"，但有观众随即在弹幕中晒出了该产品在国家药监局的备案信息，显示玻尿酸含量仅为2.3%。</p>
<p>面对质疑，主播先是沉默了将近三十秒，随后试图用"这是升级版配方"来搪塞过去。但更多观众开始涌入弹幕区，纷纷要求主播出示相关证明。</p>
<p>在舆论压力下，主播最终选择匆匆结束直播，并表示"将核实相关信息后再给大家一个交代"。然而截至发稿时，该主播和其团队仍未做出任何正式回应。</p>
<p>此事件迅速登上各大平台热搜，引发了对直播带货行业监管的广泛讨论。多位消费者权益保护人士呼吁加强对直播带货的监管力度。</p>
<p>电商平台方面表示，已关注到此事件，将对涉事商品和主播进行核查处理。</p>`,
    category: '主播塌房',
    categorySlug: 'zhubo',
    image: 'https://readdy.ai/api/search-image?query=Streaming%20studio%20setup%20with%20ring%20light%20and%20products%20on%20display%2C%20chaotic%20atmosphere%20with%20scattered%20cosmetics%2C%20dramatic%20lighting%2C%20tense%20mood%2C%20professional%20product%20photography%20style%2C%20warm%20and%20cool%20mixed%20lighting%2C%20editorial%20news%20style%2C%20clean%20minimal%20background%20with%20focus%20on%20the%20scene&width=800&height=600&seq=article-2-cover&orientation=landscape',
    date: '2026-07-05',
    views: 256000,
    comments: 8920,
    tags: ['直播带货', '虚假宣传', '翻车现场', '主播塌房'],
    isHot: true,
    isFeatured: true,
  },
  {
    id: 'article-3',
    title: '百万粉丝网红被曝学历造假，人设崩塌引发连锁反应',
    excerpt: '以"海归学霸"人设走红的某网红，被网友扒出其声称就读的海外名校并无其入学记录。人设崩塌后，多个品牌紧急与其解约。',
    content: `<p>"学霸人设"又翻车了。近日，一位拥有超过三百万粉丝的网红博主被网友扒出学历造假——其声称就读的某英国知名大学根本没有她的入学记录。</p>
<p>该网红此前一直以"留学英国名校"、"高知女性"的人设吸粉，频繁在视频中分享所谓"留学经历"和学习心得，还据此推出了多款"学霸同款"学习产品。</p>
<p>然而，有细心网友在查询该大学校友数据库时发现，完全找不到与该网红姓名匹配的学生记录。随后更多网友加入调查，最终确认该网红从未在该校就读。</p>
<p>爆料发布后，不到24小时内就有三家品牌宣布终止与该网红的合作关系。该网红的社交媒体账号也在短时间内流失了近五十万粉丝。</p>
<p>该网红随后发布了一段道歉视频，承认了学历造假行为，称自己"因为虚荣心作祟，编造了留学经历"，并表示将退还所有相关产品的收益。</p>
<p>但网友们显然并不买账，评论区清一色的"塌房打卡"，该道歉视频也成为其账号上播放量最高的一条内容。</p>`,
    category: '网红八卦',
    categorySlug: 'wanghong',
    image: 'https://readdy.ai/api/search-image?query=Graduation%20cap%20and%20diploma%20on%20a%20dark%20wooden%20desk%2C%20dramatic%20side%20lighting%20creating%20long%20shadows%2C%20mysterious%20atmosphere%2C%20slightly%20out%20of%20focus%20background%20with%20bookshelves%2C%20warm%20amber%20tones%2C%20editorial%20concept%20photography%2C%20clean%20minimal%20composition%2C%20thought-provoking%20mood&width=800&height=600&seq=article-3-cover&orientation=landscape',
    date: '2026-07-04',
    views: 189000,
    comments: 5430,
    tags: ['网红翻车', '学历造假', '人设崩塌', '品牌解约'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: 'article-4',
    title: '某女星被曝税务问题，工作室紧急发声明否认',
    excerpt: '网上突然流传某一线女星涉嫌偷税漏税的消息，引发轩然大波。该女星工作室火速发布律师声明，称将追究造谣者法律责任。',
    content: `<p>娱乐圈又爆税务风波。今日凌晨，一则关于某一线女星涉嫌偷税漏税的消息在社交平台疯传，迅速登上热搜榜首。</p>
<p>据爆料称，该女星通过设立多个空壳公司的方式，在过去三年内规避了数千万元的个人所得税。消息来源声称来自"税务机关内部人士"。</p>
<p>事件发酵仅两小时后，该女星工作室便发布了一份措辞严厉的律师声明，表示网传信息完全属于恶意造谣，工作室已委托律师对相关不实信息进行取证，并将依法追究造谣者的法律责任。</p>
<p>声明中还强调，该女星一直以来都严格遵守国家法律法规，按时足额缴纳各项税款，从未有过任何违规行为。</p>
<p>然而，有了此前多位艺人因税务问题翻车的前车之鉴，网友们对此事的反应呈现出两极分化。一部分网友选择相信工作室的声明，另一部分则持观望态度，表示"让子弹飞一会儿"。</p>
<p>截至目前，税务机关尚未对此事做出任何官方回应。</p>`,
    category: '娱乐圈黑料',
    categorySlug: 'yulequan',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20office%20interior%20with%20legal%20documents%20spread%20on%20a%20polished%20dark%20wood%20desk%2C%20dramatic%20lighting%20from%20a%20single%20desk%20lamp%2C%20tense%20business%20atmosphere%2C%20warm%20golden%20and%20deep%20shadow%20contrast%2C%20editorial%20photography%20style%2C%20clean%20composition%2C%20professional%20corporate%20aesthetic&width=800&height=600&seq=article-4-cover&orientation=landscape',
    date: '2026-07-03',
    views: 312000,
    comments: 12500,
    tags: ['娱乐圈', '税务问题', '律师声明', '女星风波'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: 'article-5',
    title: '游戏区顶流主播涉嫌代打，直播画面出现神秘镜像',
    excerpt: '某游戏区顶级主播在直播过程中，画面突然出现短暂镜像翻转，被观众发现疑似使用代打。事件持续发酵，主播至今未回应。',
    content: `<p>游戏直播圈又现"代打门"。昨晚，某拥有八百万粉丝的游戏区头部主播在直播一款热门射击游戏时，其直播画面在切换窗口的瞬间出现了短暂的镜像翻转，被敏锐的观众捕捉到。</p>
<p>技术流网友随后对直播录像进行了逐帧分析，发现该主播的键盘操作与游戏画面中的角色动作存在多处不匹配的情况。这些证据被整理成长文发布后，迅速在游戏圈引发热议。</p>
<p>所谓的"代打"是指主播本人不出镜操作，而是由幕后的高手代打，主播只负责解说和互动。这种做法在直播圈一直被视作严重的欺骗行为。</p>
<p>事件发酵后，该主播的粉丝群也出现了分裂。铁粉们坚持认为是"技术故障"和"巧合"，但更多的游戏玩家和路人观众则倾向于相信代打的说法。</p>
<p>值得注意的是，这已经是本月第二起头部游戏主播被质疑代打的事件。上一事件的当事主播最终承认了代打行为并公开道歉。</p>
<p>截至目前，该主播已经停播两天，其社交账号也未更新任何内容。</p>`,
    category: '主播塌房',
    categorySlug: 'zhubo',
    image: 'https://readdy.ai/api/search-image?query=Gaming%20setup%20with%20RGB%20lighting%20and%20multiple%20monitors%20in%20a%20dark%20room%2C%20one%20screen%20showing%20a%20glitch%20or%20reflection%20effect%2C%20tense%20competitive%20gaming%20atmosphere%2C%20dramatic%20neon%20purple%20and%20blue%20lighting%2C%20clean%20editorial%20product%20photography%2C%20mysterious%20mood&width=800&height=600&seq=article-5-cover&orientation=landscape',
    date: '2026-07-02',
    views: 198000,
    comments: 7280,
    tags: ['游戏主播', '代打风波', '直播翻车', '技术分析'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: 'article-6',
    title: '短视频平台网红因不当言论被封号，账号粉丝一夜归零',
    excerpt: '某短视频平台拥有五百万粉丝的网红，因在直播中发表不当言论，被平台处以永久封号处罚。该网红随后在其他平台发布道歉声明。',
    content: `<p>又一位网红为自己的不当言论付出了代价。昨日晚间，某短视频平台头部网红在直播中因与观众发生口角，情绪失控之下发表了严重不当的言论，引发观众大规模举报。</p>
<p>平台方面反应迅速，在该直播结束后不到半小时，就对该账号实施了永久封禁处理。该网红苦心经营三年的账号，五百多万粉丝一夜之间化为乌有。</p>
<p>随后，该网红在其他社交媒体平台上发布了一封手写道歉信，承认自己"一时冲动说错了话"，并请求大家给她一个改过自新的机会。</p>
<p>然而，网友们对此反应冷淡。许多人指出，这已经不是该网红第一次因为不当言论陷入争议，此前就曾因类似问题被平台短暂禁言过。</p>
<p>业内人士分析认为，随着网络环境的日益规范，平台对违规行为的容忍度越来越低。网红的"流量护身符"正在逐渐失效。</p>
<p>此事件也再次引发了关于网络主播素质培养和行业自律的讨论。</p>`,
    category: '网红八卦',
    categorySlug: 'wanghong',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20account%20banned%20notification%20on%20a%20minimal%20desk%2C%20dark%20moody%20lighting%2C%20frustration%20and%20regret%20atmosphere%2C%20warm%20ambient%20light%20from%20the%20screen%2C%20clean%20editorial%20style%2C%20modern%20minimal%20composition%2C%20contemplative%20mood&width=800&height=600&seq=article-6-cover&orientation=landscape',
    date: '2026-07-01',
    views: 145000,
    comments: 4890,
    tags: ['短视频', '网红封号', '不当言论', '平台处罚'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: 'article-7',
    title: '某选秀节目被曝内定冠军，赞助商连夜撤资',
    excerpt: '一档正在热播的选秀节目被内部工作人员爆料存在内定冠军的情况，消息传出后，多家赞助品牌宣布暂停合作，节目组紧急辟谣。',
    content: `<p>选秀节目的"内定"疑云再起。昨日，一位自称是某热门选秀节目幕后工作人员的用户在社交平台发布长文，详细揭露了节目组内定冠军的操作流程。</p>
<p>根据该爆料，节目组早在海选阶段就已确定了最终夺冠人选，后续的所有比赛环节都是按照剧本进行的。该工作人员还附上了多张疑似内部工作群聊的截图作为证据。</p>
<p>消息传出后，迅速在网络引发轩然大波。当晚，就有三家主要赞助品牌宣布暂停与该节目的合作，并表示将"密切关注事态发展"。</p>
<p>节目组在凌晨紧急发布声明，否认所有指控，称所谓的"内部聊天记录"属于恶意伪造，并表示已向公安机关报案。同时，节目组强调比赛过程公平公正，不存在任何内定行为。</p>
<p>然而，网友们对此并不完全信服。不少人翻出了节目中多个"疑似剧本痕迹"的片段，认为这些证据很难用巧合来解释。</p>
<p>目前，该事件仍在持续发酵中。</p>`,
    category: '娱乐圈黑料',
    categorySlug: 'yulequan',
    image: 'https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20dramatic%20spotlight%20and%20empty%20audience%20seats%2C%20behind%20the%20scenes%20atmosphere%2C%20dark%20backstage%20area%20with%20equipment%20cases%2C%20moody%20cinematic%20lighting%2C%20contrast%20between%20bright%20stage%20and%20dark%20surroundings%2C%20editorial%20entertainment%20photography%2C%20clean%20composition&width=800&height=600&seq=article-7-cover&orientation=landscape',
    date: '2026-06-30',
    views: 275000,
    comments: 9870,
    tags: ['选秀节目', '内定冠军', '赞助商撤资', '节目组辟谣'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: 'article-8',
    title: '知名美食博主被曝视频造假，摆拍浪费食物引发众怒',
    excerpt: '以"大胃王"和"美食探店"走红的某博主，被拍到在拍摄后将食物全部倒掉。视频曝光后引发众怒，评论区被网友攻陷。',
    content: `<p>美食博主的"假吃"问题再次引发关注。近日，一位路人偶然拍到了某知名美食博主在拍摄完"大胃王挑战"视频后，将桌上的大量食物直接倒入垃圾桶的画面。</p>
<p>该视频被上传到网络后迅速传播开来。画面清晰地显示，该博主在摄像机停止录制后，立刻放下了手中的食物，让助理将桌上剩余的菜品全部清理掉。</p>
<p>这与该博主一直在视频中塑造的"热爱美食、从不浪费"的人设形成了强烈的反差。许多曾经喜爱该博主的网友表示感到"被欺骗了"。</p>
<p>事件发酵后，该博主的社交账号在一天之内掉粉超过二十万。其之前发布的数百条"美食挑战"视频的评论区也被愤怒的网友刷屏，纷纷要求其公开道歉。</p>
<p>该博主随后发布了一段道歉视频，承认确实存在食物浪费行为，表示"意识到了问题的严重性"，并承诺今后将改变拍摄方式，确保不再浪费食物。</p>
<p>然而，这一道歉并没有平息网友的愤怒。许多人认为，在国家大力倡导节约粮食的背景下，这种行为尤其不可原谅。</p>`,
    category: '网红八卦',
    categorySlug: 'wanghong',
    image: 'https://readdy.ai/api/search-image?query=Food%20waste%20in%20a%20restaurant%20setting%2C%20delicious%20dishes%20being%20discarded%2C%20dramatic%20contrast%20between%20beautiful%20food%20presentation%20and%20waste%2C%20moral%20dilemma%20concept%2C%20warm%20restaurant%20lighting%2C%20editorial%20documentary%20style%2C%20thought-provoking%20composition%2C%20clean%20minimal%20background&width=800&height=600&seq=article-8-cover&orientation=landscape',
    date: '2026-06-29',
    views: 167000,
    comments: 6120,
    tags: ['美食博主', '视频造假', '浪费食物', '人设崩塌'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: 'article-9',
    title: '某女团成员被曝与经纪公司存在合约纠纷，或将解约单飞',
    excerpt: '人气女团成员被曝与所属经纪公司存在严重的合约纠纷，涉及收入分配不公和强制续约等问题。粉丝联名发声支持偶像维权。',
    content: `<p>偶像团体的合约问题再次浮出水面。据韩媒报道，某人气女团的中国籍成员与所属经纪公司之间存在严重的合约纠纷，目前双方已进入法律程序。</p>
<p>消息称，该成员认为公司在收入分配上存在严重不公——她作为团队中人气最高的成员之一，承担了绝大部分的商业活动和代言工作，但在收入分成上却与其他成员完全一致。</p>
<p>此外，公司还涉嫌在合约到期前单方面要求该成员签署一份时效更长、条件更为苛刻的新合约，遭到该成员拒绝后，公司便开始减少其曝光机会。</p>
<p>该成员的粉丝群体在得知消息后，迅速组织了联名请愿活动，并在社交媒体上发起了话题标签，声援偶像的维权行动。话题在24小时内的阅读量突破了五亿次。</p>
<p>业内人士分析，如果该成员最终选择解约单飞，按照其目前的人气和商业价值，将有可能创造偶像解约赔偿金的新纪录。</p>
<p>截至目前，经纪公司尚未对此事做出正式回应。</p>`,
    category: '娱乐圈黑料',
    categorySlug: 'yulequan',
    image: 'https://readdy.ai/api/search-image?query=K-pop%20style%20stage%20with%20dramatic%20spotlight%20on%20a%20single%20microphone%20stand%2C%20empty%20stage%20symbolizing%20solo%20career%2C%20dark%20background%20with%20bright%20center%20spotlight%2C%20emotional%20atmosphere%2C%20cinematic%20lighting%2C%20clean%20minimal%20composition%2C%20editorial%20entertainment%20photography&width=800&height=600&seq=article-9-cover&orientation=landscape',
    date: '2026-06-28',
    views: 198000,
    comments: 7560,
    tags: ['女团', '合约纠纷', '解约单飞', '粉丝声援'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: 'article-10',
    title: '直播平台惊现"剧本带货"产业链，演员时薪曝光',
    excerpt: '调查发现，部分直播带货存在完整的"剧本带货"产业链。从演员雇佣到剧本编写再到假数据生成，已形成一条龙服务。',
    content: `<p>直播带货行业的黑幕再度被揭开。一项深入调查显示，部分中小主播的直播间中存在着一条完整的"剧本带货"产业链，其规模和专业化程度令人震惊。</p>
<p>据调查，这些直播间会雇佣大量"群众演员"扮演真实消费者。这些演员的时薪从50元到200元不等，根据其"演技水平"和在直播间中扮演的角色不同而有所差异。</p>
<p>更令人惊讶的是，还有专业的"剧本写手"负责设计直播间的互动剧情。从最初的"质疑产品"到最后的"被主播说服下单"，每一个环节都有精心设计的脚本。</p>
<p>此外，还有专门的技术团队负责为直播间刷数据——包括在线观看人数、点赞量、评论数等多个维度的数据都可以被伪造。</p>
<p>一位曾在该行业工作的内部人士透露："一个中小型直播间，如果全套'剧本'上齐，一场直播的成本大约在3-5万元，但通过虚假的抢购氛围，销售额可以轻松突破50万元。ROI非常可观。"</p>
<p>消费者权益保护组织表示，这种行为已经涉嫌欺诈，呼吁相关部门加强监管。</p>`,
    category: '主播塌房',
    categorySlug: 'zhubo',
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20live%20streaming%20studio%2C%20multiple%20people%20working%20with%20scripts%20and%20monitors%2C%20industrial%20warehouse%20setting%20converted%20to%20studio%2C%20dramatic%20documentary%20lighting%2C%20expose%20journalism%20style%2C%20warm%20and%20cool%20mixed%20tones%2C%20clean%20composition%2C%20investigative%20mood&width=800&height=600&seq=article-10-cover&orientation=landscape',
    date: '2026-06-27',
    views: 223000,
    comments: 8430,
    tags: ['直播带货', '剧本带货', '产业链', '行业黑幕'],
    isHot: false,
    isFeatured: true,
  },
  {
    id: 'article-11',
    title: '某网络歌手新歌被指抄袭，原作者发律师函维权',
    excerpt: '近期爆火的某网络歌手新歌被指旋律与一首海外歌曲高度相似，海外原作者通过社交媒体发声维权，并已委托律师发出正式函件。',
    content: `<p>又一起音乐抄袭争议在网络上炸开了锅。近期在短视频平台爆火的一首网络歌曲，被多位乐迷指出其副歌旋律与一首三年前发行的海外独立音乐人的作品高度相似。</p>
<p>经过专业音乐人的对比分析，两首歌曲在副歌部分的旋律走向、节奏型以及和声进行上的确存在多处重合，相似度被评估为"极不可能是独立创作"。</p>
<p>海外原作者在得知此事后，通过社交媒体发布了一段对比视频，并用中英文双语表示已经注意到了这首"非常相似"的歌曲，同时透露已委托律师向该网络歌手发出正式律师函。</p>
<p>该网络歌手方面最初保持沉默，但在舆论压力下，于昨日晚间发布声明称"巧合相似在音乐创作中常有发生"，否认抄袭指控。</p>
<p>然而这一回应显然无法让公众信服。多位音乐圈资深人士公开表示支持海外原作者维权，认为这种程度的相似已经超出了"巧合"的范畴。</p>
<p>目前该网络歌手的这首歌曲在多个音乐平台上的评论区已被相关讨论占据。</p>`,
    category: '网红八卦',
    categorySlug: 'wanghong',
    image: 'https://readdy.ai/api/search-image?query=Music%20sheet%20and%20headphones%20on%20a%20dark%20wooden%20desk%2C%20dramatic%20side%20lighting%2C%20creative%20dispute%20mood%2C%20half%20of%20the%20sheet%20in%20shadow%2C%20conceptual%20artistic%20photography%2C%20warm%20ambient%20tones%2C%20clean%20minimal%20composition%2C%20contemplative%20atmosphere&width=800&height=600&seq=article-11-cover&orientation=landscape',
    date: '2026-06-26',
    views: 156000,
    comments: 5230,
    tags: ['网络歌手', '抄袭争议', '律师函', '原创维权'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: 'article-12',
    title: '热门综艺录制现场发生意外，多名嘉宾受伤送医',
    excerpt: '某户外竞技类综艺在录制过程中发生安全事故，导致三名嘉宾不同程度受伤。节目组紧急暂停录制，受伤嘉宾已被送往医院治疗。',
    content: `<p>综艺节目安全问题再次拉响警报。昨日下午，某热门户外竞技类综艺节目在浙江某景区录制时发生意外事故，导致参与录制的三名牌嘉宾不同程度受伤。</p>
<p>据了解，事故发生在节目组设置的一个高空挑战环节中。当一名嘉宾正在完成挑战时，安全绳索突然出现松动，该嘉宾从约五米高的位置跌落。在营救过程中，另外两名上前帮忙的嘉宾也受了轻伤。</p>
<p>事故发生后，节目组立即暂停了所有录制工作，并紧急联系了120急救。三名受伤嘉宾已被送往最近的医院进行救治。据医院方面透露，主要受伤嘉宾被诊断为腿部骨折，需要住院治疗，其余两人为轻微擦伤，已经出院。</p>
<p>节目组随后发布声明，向受伤嘉宾及其家属表示诚挚歉意，并承诺将承担全部医疗费用。同时表示将对所有录制设备进行全面安全排查，杜绝此类事件再次发生。</p>
<p>然而，这一事件还是引发了公众对综艺节目安全问题的广泛关注。不少网友指出，近年来综艺节目为了追求刺激和收视率，不断加大挑战难度，安全隐患日益突出。</p>
<p>相关监管部门表示，将对此事件展开调查。</p>`,
    category: '社会热点',
    categorySlug: 'shehui',
    image: 'https://readdy.ai/api/search-image?query=Outdoor%20adventure%20obstacle%20course%20with%20safety%20equipment%2C%20dramatic%20mountain%20scenery%20in%20background%2C%20overcast%20weather%20creating%20tense%20atmosphere%2C%20empty%20course%20after%20incident%2C%20documentary%20photojournalism%20style%2C%20clean%20composition%2C%20serious%20mood%20with%20natural%20lighting&width=800&height=600&seq=article-12-cover&orientation=landscape',
    date: '2026-06-25',
    views: 289000,
    comments: 11200,
    tags: ['综艺事故', '安全隐忧', '嘉宾受伤', '录制意外'],
    isHot: false,
    isFeatured: false,
  },
];

export function getArticlesByCategory(slug: string): ArticleItem[] {
  return articles.filter((a) => a.categorySlug === slug);
}

export function getArticleById(id: string): ArticleItem | undefined {
  return articles.find((a) => a.id === id);
}

export function getFeaturedArticles(): ArticleItem[] {
  return articles.filter((a) => a.isFeatured);
}

export function getHotArticles(): ArticleItem[] {
  return articles.filter((a) => a.isHot);
}

export function getLatestArticles(limit: number = 9): ArticleItem[] {
  return [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, limit);
}